import React, { ReactElement } from 'react';
import * as RadixSelect from '@radix-ui/react-select';
import { CheckIcon, ChevronDownIcon } from '@radix-ui/react-icons';

interface SelectOptionProps {
  label: string;
  value: string;
}

interface SelectProps {
  children: ReactElement;
  defaultValue: string;
  value: string;
  onValueChange: (v: string) => void;
}

export const SelectOption = ({ label, value }: SelectOptionProps) => {
  return (
    <RadixSelect.Item
      value={value}
      className="flex items-center px-4 py-2 text-sm text-gray-700 rounded-md cursor-pointer hover:bg-gray-100"
    >
      <RadixSelect.ItemText>{label}</RadixSelect.ItemText>
      <RadixSelect.ItemIndicator>
        <CheckIcon className="w-4 h-4 text-blue-500" />
      </RadixSelect.ItemIndicator>
    </RadixSelect.Item>
  );
};

export const Select = ({ children, defaultValue, value, onValueChange }: SelectProps) => {
  return (
    <RadixSelect.Root onValueChange={onValueChange} value={value}>
      <RadixSelect.Trigger
        className="inline-flex items-center justify-between w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        aria-label="Food"
      >
        <RadixSelect.Value placeholder={defaultValue} />
        <RadixSelect.Icon className="ml-2">
          <ChevronDownIcon className="w-5 h-5 text-gray-500" />
        </RadixSelect.Icon>
      </RadixSelect.Trigger>
      <RadixSelect.Portal>
        <RadixSelect.Content className="z-50 bg-white rounded-md shadow-lg border border-gray-200" position="popper">
          <RadixSelect.ScrollUpButton className="flex items-center justify-center h-6 text-gray-500">↑</RadixSelect.ScrollUpButton>
          <RadixSelect.Viewport className="p-1 max-h-80">{children}</RadixSelect.Viewport>
          <RadixSelect.ScrollDownButton className="flex items-center justify-center h-6 text-gray-500">↓</RadixSelect.ScrollDownButton>
        </RadixSelect.Content>
      </RadixSelect.Portal>
    </RadixSelect.Root>
  );
};
